<template>
    <div class="sdr-box contact-box">
        <h4>{{ needhelp[getCurrentLocale] }}</h4>
        <p>{{ sideboxhelptext[getCurrentLocale] }}</p>
        <address class="contact-details">
            <span class="contact-phone"><i class="soap-icon-phone"></i> +49 30 53676791</span>
            <br>
            <a href="mailto:kundenservice@sundair.com" class="contact-email">kundenservice@sundair.com</a>
        </address>

        <br /><h4>{{ forbeirut[getCurrentLocale] }}</h4>
        <address class="contact-details">
            <span class="contact-phone"><i class="soap-icon-phone"></i> +49 30 81455700</span>
            <br>
            <a href="mailto:bey@sundair.com" class="contact-email">bey@sundair.com</a>
        </address>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                needhelp: {
                    en: 'Do you need any help or support?',
                    de: 'Benötigen Sie Hilfe oder Unterstützung?',
                },
                sideboxhelptext: {
                    en: 'We will be happy to help you. Our customer service is available monday - friday from 09 a.m. - 06 p.m.',
                    de: 'Wir helfen Ihnen gern weiter. Unser Kundenservice steht Ihnen telefonisch Mo-Fr in der Zeit von 09-18 Uhr zur Verfügung.',
                },
                forbeirut: {
                    en: 'For Beirut Flights:',
                    de: 'Für Beirut Flüge:',
                }
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
</style>